import { type ReactNode } from 'react';
import { Menu } from 'lucide-react';
import { Button } from '../ui/button';
import type { RouteTitle } from './types';

interface HeaderProps {
  head: RouteTitle;
  onOpenMobileNav: () => void;
  /** Optional app-specific search input rendered between title and actions. */
  searchSlot?: ReactNode;
  /** Optional app-specific action buttons rendered before the theme toggle. */
  actions?: ReactNode;
}

export function Header({ head, onOpenMobileNav, searchSlot, actions }: HeaderProps) {
  return (
    <header className="flex min-h-[56px] flex-shrink-0 items-center gap-2 border-b border-border bg-card px-3 pb-[max(env(safe-area-inset-bottom),0px)] pt-[max(env(safe-area-inset-top),0px)] sm:h-[54px] sm:px-5">
      <Button
        variant="ghost"
        size="icon"
        className="h-9 w-9 md:hidden"
        onClick={onOpenMobileNav}
        aria-label="Open navigation"
      >
        <Menu className="h-5 w-5" />
      </Button>
      <div className="min-w-0 flex-1">
        <h1 className="truncate text-[15px] font-semibold leading-tight">
          {head.title}
          {head.sub && (
            <span className="ml-0 mt-0.5 block text-[11px] font-normal text-muted-foreground sm:ml-2 sm:mt-0 sm:inline">
              {head.sub}
            </span>
          )}
        </h1>
      </div>

      {searchSlot}

      {actions}
    </header>
  );
}
